import { useEffect } from "react";
import MainHeroBanner from "../../assets/images/spinner/radial-bg.svg";
import AchievementLogo from "../../assets/images/game-board/achievement-badge.png";
import Avatar1 from "../../assets/images/comman/avatar1.png";

interface TeamAchievementModalProps {
  isOpen: boolean;
  onClose: () => void;
  participantId: number | null;
}

const AchievementBadge = ({ title, secondtitle, isUnlocked = true }: any) => {
  return (
    <div className="flex flex-col items-center 2xl:w-[calc(25%-0.625vw)] sm:w-[calc(25%-18px)] xs:w-[calc(33.33%-11px)] w-[calc(50%-8px)]">
      <div className="relative flex flex-col items-center">
        <div className={`relative`}>
          <img src={AchievementLogo} alt="achievement-badge" className="2xl:h-[9.375vw] h-[180px]" />
          <span className="absolute 2xl:top-[3.542vw] top-17 transform -rotate-[8deg] font-bold 2xl:text-[1vw]/tight text-xl/tight text-white mx-auto w-full text-center">
            {title}
          </span>
          <span className="absolute 2xl:top-[6.458vw] top-31 transform -rotate-[8deg] font-bold 2xl:text-[1vw]/tight text-xl/tight text-white mx-auto w-full text-center">
            {secondtitle}
          </span>
        </div>
      </div>
    </div>
  );
};

const TeamAchievementModal = ({ isOpen, onClose, participantId }: TeamAchievementModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const unlockedAchievements = [
    { title: "Traditions", secondtitle: "Guru" },
    { title: "Sports", secondtitle: "Expert" },
    { title: "Music", secondtitle: "Master" },
    { title: "All", secondtitle: "Rounder" },
  ];

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
      <div
        // style={{ backgroundImage: `url(${MainHeroBanner})` }}
        className="bg-center bg-cover modal bg-primary-skyblue 2xl:rounded-[2.083vw] md:rounded-[40px] rounded-3xl 2xl:p-[2.083vw] md:p-7 p-4 2xl:max-w-[37.292vw] md:max-w-[716px] max-w-3xl w-full relative animate-[slideUp_0.3s_ease-out] 2xl:border-[0.2vw] border-3 border-primary overflow-auto 2xl:max-h-[calc(100dvh-1.042vw)] max-h-[calc(100dvh-20px)] hide-scroll"
      >
        {/* Avatar */}
        <div className="flex items-center 2xl:gap-[0.833vw] md:gap-3 gap-2 justify-center w-fit 2xl:mb-[1vw] mb-3 mx-auto">
          <div
            className="mx-auto 2xl:w-[2.5vw] xl:w-[40px] lg:w-10 w-10 2xl:min-w-[2.5vw] xl:min-w-[40px] lg:min-w-10 min-w-10 2xl:h-[2.5vw] xl:h-[40px] lg:h-10 h-10 aspect-square overflow-hidden
                    bg-[#97A4F2] skew-x-[-10deg]
                    2xl:border-[0.104vw] border-[1.5px] 2xl:rounded-[0.26vw] rounded-[5px] 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]"
          >
            <img className="w-full h-full object-cover" src={Avatar1} alt="avatar" />
          </div>
          <h2 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/tight md:text-2xl/6 text-xl/5 font-bold text-primary-rose text-start w-fit">
            Ahmed Farouqi’s Achievements
          </h2>
        </div>
        <div className="text-center 2xl:mb-[1.5vw] mb-5">
          <hr className="border-0 2xl:h-[0.053vw] h-[1px] w-full [background:linear-gradient(90deg,rgba(11,51,105,0)_0%,#7364FF_50%,rgba(11,51,105,0)_100%)]" />
        </div>

        {/* Unlocked Achievements */}

        <div className="flex flex-wrap justify-center w-full 2xl:gap-[0.833vw] gap-4">
          {unlockedAchievements.map((achievement, index) => (
            <AchievementBadge
              key={index}
              title={achievement.title}
              secondtitle={achievement.secondtitle}
              isUnlocked={true}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamAchievementModal;
